<script setup lang="ts">
import { computed } from 'vue'
import { useFormatDate } from '../composables/formatDate'
import { useQuasar } from 'quasar'
import sanitizeHtml from 'sanitize-html'
const props = withDefaults(
  defineProps<{
    sent: boolean
    priority: boolean
    from: { name: string; username: string } | null
    to: { name: string; username: string } | null
    subject: string
    body: string
    date: Date
    read: boolean
    attachment?: boolean
  }>(),
  {
    sent: false,
  }
)

/**Renders time if today, date if previous day */
const renderDate = computed(() => {
  if (
    new Date().getDate() == props.date.getDate() &&
    new Date().getMonth() == props.date.getMonth() &&
    new Date().getFullYear() == props.date.getFullYear()
  ) {
    //render time
    return `${useFormatDate(props.date).time()}`
  } else {
    return `${useFormatDate(props.date).month({ month: 'short' })} ${useFormatDate(
      props.date
    ).day()}`
  }
})
const unread = computed(() => !props.read)
const bodySanitized = computed(() => {
  return sanitizeHtml(props.body, {
    allowedTags: [],
  })
    .replaceAll('&gt;', '>')
    .replaceAll('&lt;', '<')
})
//for ripple.
const $q = useQuasar()
defineExpose({ $q })
</script>
<template>
  <q-item clickable v-ripple>
    <q-item-section side>
      <span :class="unread ? 'text-weight-bold' : ''" class="text-black tw-w-36 tw-truncate">
        {{ sent ? `To: ${to?.name}` : from?.name }}
      </span>
    </q-item-section>
    <q-item-section>
      <q-item-label lines="1">
        <q-avatar
          v-if="priority"
          rounded
          color="warning"
          size="xs"
          text-color="black"
          icon="priority_high"
          class="q-mr-xs"
          font-size=".8rem"
        />
        <span :class="unread ? 'text-weight-bold' : ''" class="text-black">{{ subject }}</span>
        <span class="text-grey-7">
          -
          {{ bodySanitized.replaceAll('&gt;', '>').replaceAll('&lt;', '<') }}
        </span>
      </q-item-label>
    </q-item-section>
    <q-item-section v-if="attachment" side>
      <q-icon name="attachment" />
    </q-item-section>
    <q-item-section side>
      <span :class="unread ? 'text-weight-bold' : ''" class="text-black text-right tw-w-16">
        {{ renderDate }}
      </span>
    </q-item-section>
  </q-item>
</template>
